import React, { useEffect } from "react";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { useAppSelector } from "../../../app/hooks";
import ButtonWithLoading from "../../../components/common/ButtonWithLoading";
import { Typography } from "@progress/kendo-react-common";
import { requiredValidator } from "../../../components/formFields/CommonValidator";
import ShadowCard from "../../../components/common/ShadowCard";
import FormDatePicker from "../../../components/formFields/FormDateField";
import moment from "moment";

interface ChangeWatcherProps {
  formRenderProps: FormRenderProps;
}

const ChangeWatcher: React.FC<ChangeWatcherProps> = ({ formRenderProps }) => {
  useEffect(() => {
    formRenderProps.onChange("filterFromDate", {
      value: moment().startOf("month").toDate(),
    });
    formRenderProps.onChange("filterToDate", {
      value: moment().toDate(),
    });
  }, []);
  return null;
};

const PromocodeUsageReportForm: React.FC = () => {
  const loading = useAppSelector((state) => state.reports.loading);

  const handleSubmit = (values: any) => {
    const payload: any = {};

    payload.filterFromDate = values?.filterFromDate
      ? moment(values?.filterFromDate).format("YYYY-MM-DD")
      : "0";
    payload.filterToDate = values?.filterToDate
      ? moment(values?.filterToDate).format("YYYY-MM-DD")
      : "0";
    window.open(
      `promocodeusagereportview/${payload?.filterFromDate}/${payload?.filterToDate}`,
    );
  };

  return (
    <GridLayout gap={{ rows: 10 }} cols={[{ width: "100%" }]}>
      <GridLayoutItem>
        <ShadowCard>
          <Form
            onSubmit={handleSubmit}
            render={(formRenderProps: FormRenderProps) => (
              <FormElement style={{ width: "100%" }}>
                <GridLayout
                  style={{ marginRight: 20 }}
                  gap={{ cols: 10, rows: 0 }}
                  cols={[{ width: "40%" }, { width: "30%" }, { width: "30%" }]}
                >
                  <GridLayoutItem colSpan={3}>
                    <Typography.h4
                      style={{ marginBottom: 0, marginLeft: "3px" }}
                    >
                      Promocode Usage Report
                    </Typography.h4>
                  </GridLayoutItem>
                  <GridLayoutItem style={{ display: "flex", gap: 10 }}>
                    <Field
                      name="filterFromDate"
                      label="From Date"
                      format="dd/MM/yyyy"
                      wrapperStyle={{ width: "100%" }}
                      component={FormDatePicker}
                      astrike={true}
                      validator={requiredValidator}
                    />
                    <Field
                      name="filterToDate"
                      label="To Date"
                      format="dd/MM/yyyy"
                      minDate={moment(
                        formRenderProps.valueGetter("filterFromDate"),
                      ).toDate()}
                      wrapperStyle={{ width: "100%" }}
                      component={FormDatePicker}
                      astrike={true}
                      validator={requiredValidator}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem
                    style={{
                      marginTop: 34,
                    }}
                  >
                    <ButtonWithLoading
                      label={"Get Details"}
                      type="submit"
                      Size="medium"
                      disabled={!formRenderProps.allowSubmit || loading}
                      loading={loading}
                    />
                  </GridLayoutItem>
                </GridLayout>
                <ChangeWatcher formRenderProps={formRenderProps} />
              </FormElement>
            )}
          />
        </ShadowCard>
      </GridLayoutItem>
    </GridLayout>
  );
};

export default PromocodeUsageReportForm;
